const actions = {
  SET_BASE_PATH: "SET_BASE_PATH",
  FETCH: "FETCH",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_ERROR: "FETCH_ERROR",
  // SYNC_COLLECTION: "SYNC_COLLECTION",
  SYNC_COLLECTION_SUCCESS: "SYNC_COLLECTION_SUCCESS",
  SYNC_COLLECTION_ERROR: "SYNC_COLLECTION_ERROR",
  UPDATE_COLLECTIONS_LIST: "UPDATE_COLLECTIONS_LIST",
  SET_SELECTED_PATHS: "SET_SELECTED_PATHS",
  CHANNEL_SUBSCRIBE_SUCCESS: "CHANNEL_SUBSCRIBE_SUCCESS",
  CHANNEL_UNSUBSCRIBE_SUCCESS: "CHANNEL_UNSUBSCRIBE_SUCCESS",
  fetch: (collectionId, options) => {
    return (dispatch) => {
      // console.log("fetchCollection:", collectionId, options);
      dispatch({
        type: "API:" + (options.path || options.url || actions.FETCH),
        collectionId,
        options: {
          method: "GET",
          ...options,
        },
      });
    };
  },
  sync: (...collectionIds) => {
    return (dispatch, getState) => {
      // console.log("syncCollection:", collectionIds);
      const collections = collectionIds.map((collectionId) => {
        const collection =
          getState()
            .Collections?.data?.[getState().Collections.basePath + "/collections/" + collectionId];
        // const orderByList = collection?.orderBy
        return {
          collectionId,
          options: {
            // fields: {">": {[orderByList[0].field]: startAfterDate}},
            order: collection?.orderBy
            ?.map?.((orderBy) =>
              [orderBy.field, orderBy.direction || "desc"]),
          },
        }
        // const orderByList = collection?.orderBy;
        // const orderByFieldProps = collection?.schema?.properties?.[orderByList?.[0]?.field];

        // if (!orderByList?.length) {
        //   dispatch({
        //     type: actions.SYNC_COLLECTION_ERROR,
        //     collectionId,
        //     error: "No orderBy field specified for collection: " + collectionId,
        //   });
        //   return;
        // }

        // if (orderByFieldProps &&
        //   orderByFieldProps.type !== "number" &&
        //   orderByFieldProps.type !== "integer" &&
        //   orderByFieldProps.type !== "Timestamp" &&
        //   orderByFieldProps.type !== "DateTime" &&
        //   orderByFieldProps.type !== "Date" &&
        //   orderByFieldProps.type !== "Time" &&
        //   orderByFieldProps.format !== "date-time") {
        //   dispatch({
        //     type: actions.SYNC_COLLECTION_ERROR,
        //     collectionId,
        //     error: "OrderBy field must be of type Timestamp or DateTime but is: " + orderByFieldProps.type + ".",
        //   });
        //   return;
        // }
      });


      // const startAfterDat =
      //   (collection?.viewed && new Date(collection.viewed)) ||
      //   (getState().App?.startTime && new Date(getState().App?.startTime)) ||
      //   new Date();

      // const startAfterDate =
      //   new Date(
      //     Math.max(collection?.viewed, getState().App?.startTime)
      //     || Date.now(),
      //   );

      // console.log(
      //   "action:", "SYNC/COLLECTION/" + collectionId.toUpperCase(), {
      //     collection,
      //     orderByList,
      //     orderByFieldProps,
      //     // startAfterDate,
      //     v: collection?.viewed,
      //     viewed: collection?.viewed && new Date(collection.viewed),
      //     viewedTs: collection?.viewed && new Date(collection.viewed).getTime(),
      //     startTime: new Date(getState().Collections?.startTime),
      //     s: getState().Collections?.startTime,
      //   });

      dispatch({
        type: "SYNC/COLLECTION/" + collectionIds.length,
        // collectionId,
        // unsubscribe: false,
        collections,
      });
    };
  },
  // listen: (subscribe, ...collectionIds) => {
  //   return (dispatch, getState) => {
  //     collectionIds
  //     .forEach((collectionId) => {
  //       const collection = getState()
  //         .Collections?.data?.[getState().Collections.basePath + "/collections/" + collectionId];
  //
  //       console.log("listen:", collectionId, collection);
  //
  //       const orderByList = collection?.orderBy;
  //
  //       const orderByFieldProps = collection?.schema?.properties?.[orderByList?.[0]?.field];
  //
  //       if (!orderByList?.length) {
  //         dispatch({
  //           type: actions.SYNC_COLLECTION_ERROR,
  //           collectionId,
  //           error: "No orderBy field specified for collection: " + collectionId,
  //         });
  //         return;
  //       }
  //
  //       if (orderByFieldProps &&
  //         orderByFieldProps.type !== "number" &&
  //         orderByFieldProps.type !== "integer" &&
  //         orderByFieldProps.type !== "Timestamp" &&
  //         orderByFieldProps.type !== "DateTime" &&
  //         orderByFieldProps.type !== "Date" &&
  //         orderByFieldProps.type !== "Time" &&
  //         orderByFieldProps.format !== "date-time") {
  //         dispatch({
  //           type: actions.SYNC_COLLECTION_ERROR,
  //           collectionId,
  //           error: "OrderBy field must be of type Timestamp or DateTime but is: " + orderByFieldProps.type + ".",
  //         });
  //         return;
  //       }
  //
  //       // const startAfterDat =
  //       //   (collection?.viewed && new Date(collection.viewed)) ||
  //       //   (getState().App?.startTime && new Date(getState().App?.startTime)) ||
  //       //   new Date();
  //
  //       const startAfter =
  //           Math.max(collection?.viewed, getState().App?.startTime)
  //           || Date.now();
  //
  //       console.log(
  //         "action:", "SYNC/COLLECTION/" + collectionId.toUpperCase(), {
  //           collection,
  //           orderByList,
  //           orderByFieldProps,
  //           startAfter,
  //           v: collection?.viewed,
  //           viewed: collection?.viewed && new Date(collection.viewed),
  //           viewedTs: collection?.viewed && new Date(collection.viewed).getTime(),
  //           startTime: new Date(getState().Collections?.startTime),
  //           s: getState().Collections?.startTime,
  //         });
  //
  //       dispatch({
  //         type: "SYNC/COLLECTION/" + collectionId.toUpperCase(),
  //         collectionId,
  //         unsubscribe: !subscribe,
  //         options: {
  //           fields: {">": {[orderByList[0].field]: startAfter}},
  //           order: orderByList
  //             ?.map?.((orderBy) =>
  //               [orderBy.field, orderBy.direction || "desc"]),
  //         },
  //       });
  //     });
  //   };
  // },
  // toggleListeners: (subscribe, ...collectionIds) => {
  //   return (dispatch) => {
  //     collectionIds
  //     .forEach((collectionId) =>
  //       dispatch({
  //         type: actions.SYNC_COLLECTION,
  //         collectionId,
  //         unsubscribe: !subscribe,
  //       }));
  //   };
  // },
  // updateCollectionsLists: () => {
  //   return (dispatch, getState) => {
  //     // console.log("updateMetaLists");
  //     const pinned = getState().Collections.collections?.items?.reduce?.(($acc, item) => {
  //       getState().Collections.data?.[item.path]?.pin === true &&
  //       $acc.push(item.id);
  //       return $acc;
  //     }, []) || [];
  //
  //     dispatch({
  //       type: actions.UPDATE_COLLECTIONS_LIST,
  //       lists: {
  //         pinned,
  //       },
  //     });
  //   };
  // },
  setSelectedPaths: (collectionId, selectedPaths) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_SELECTED_PATHS,
        selectedPaths,
        collectionId,
      });
    };
  }
};

export default actions;
